/** 데이터 없이 레이아웃만 확인할 때 셀에 넣는 고정 자리표시자 */
export const RESULT_DESIGN_PLACEHOLDER = '예정';
